export const REQUEST_BY_QUERYSTRING = 'REQUEST_BY_QUERYSTRING';
export const RECEIVE_BY_QUERYSTRING = 'RECEIVE_BY_QUERYSTRING';

export const REQUEST_BY_ID = 'REQUEST_BY_ID';
export const RECEIVE_BY_ID = 'RECEIVE_BY_ID';



/** WEBPACK FOOTER **
 ** ./src/constants/actionTypes.js
 **/